import { OnboardingStep } from '../../../../services/exports/Constants';

export default {
  [OnboardingStep.EmailVerification]: 'Confirmați adresa de email',
  [OnboardingStep.StoreDetails]: 'Detalii locație',
  [OnboardingStep.BusinessInfo]: 'Detalii companie',
  // Outside Germany, where Store details and Business details are still one step.
  store_and_business_info: 'Adăugați detaliile magazinului',
  [OnboardingStep.PersonalInfo]: 'Adăugați informațiile personale',
  // In Germany: the person who signs the contract, for a GmbH its managing director (Nishita).
  owner_personal_info: 'Informații personale ale proprietarului',
  owner_personal_info_gmbh: 'Informații personale ale proprietarului / administratorului',
  [OnboardingStep.ShippingInfo]: 'Adăugați informațiile de livrare',
  [OnboardingStep.BankInfo]: 'Adăugați datele bancare pentru plăți',
  [OnboardingStep.TaxInfo]: 'Afacerea dvs. este înregistrată în scopuri de TVA?',
  [OnboardingStep.BusinessDocs]: 'Document doveditor al afacerii',
  [OnboardingStep.PersonalDocs]: 'Document de identitate',
  [OnboardingStep.InfoSubmission]: 'Primiți plăți',
  confirm_info_gateway: 'Primiți plăți – {{paymentGateway}}',
  [OnboardingStep.PaymentInfo]: 'Informații de plată',
  [OnboardingStep.Subscription]: 'Abonament',
  [OnboardingStep.MobileApp]: 'Aplicație mobilă',
  [OnboardingStep.DeliveryStructure]: 'Structura livrării',
  [OnboardingStep.Contract]: 'Contract',
  [OnboardingStep.ContractPayment]: 'Plată contract',
  [OnboardingStep.Documents]: 'Încarcă documente',
  [OnboardingStep.PromoCode]: 'Cod promoțional',
};
